<template>
  <cms-base-button-action v-if="props.type === 'VfCanvasActionLink'" v-bind="props" />
  <cms-base-button-simple v-else v-bind="props" />
</template>

<script lang="ts" setup>
import type { Target } from '#types/target'

const props = defineProps<Target>()
</script>
